import i18n from 'i18n-js'
import fr from './fr.json'
import './date'

i18n.translations = { fr: { ...fr } }
i18n.locale = 'fr'
